import React, { useState, useEffect } from 'react';

import { NoticeBar, Button, Toast, List, Modal, Accordion } from 'antd-mobile';

import { CreateChannelControl, UpdateChannelControl, addChannelRecord } from '../../../api/usms';
import {
  RecordCreateType,
  RecordUpdateType,
  ChannelType,
  ProtoType,
  Purpose,
  AllOperatorType
} from '../utils/const';
import ConfigEditorProvider from './ConfigEditorProvider';
import { arrayGroupByObjectKey } from '../utils/common';

import { Radios } from '../components';

const alert = Modal.alert;
const SelectPurpose = { ...Purpose, ...{ All: "通用" } };

const sumWeight = 100; //权重总和不超过100

const types = {
  all: '全部',
  other: '单条运营商',
};

/* 编辑通道配置 */
function IsmsConfigEditor(props) {
  const { info, channelType, fetchBack, searchInfo } = props;

  const [allList, setAllList] = useState([]);
  const [vendorList, setVendorList] = useState([]);
  const [operatorType, setOperatorType] = useState('all');
  const [btnLoading, setBtnLoading] = useState(false);

  // 初始化编辑数据
  useEffect(() => {
    if (info && info.ChannelWeight) {
      let channelList = [];
      try {
        channelList = JSON.parse(info.ChannelWeight) || [];
      } catch {
        channelList = [];
      }

      setAllList(channelList.filter(channel => channel.Provider === 'all' || channel.Provider === ''));
      setVendorList(channelList.filter(channel => channel.Provider !== 'all' && channel.Provider !== ''));
      if (channelList.some(item => item.Provider === 'all' || item.Provider === '')) {
        setOperatorType('all');
      } else {
        setOperatorType('other');
      }
    }
    // eslint-disable-next-line
  }, [info]);

  const handleOk = () => {
    if (checkWeight()) {
      const weights = getResult();

      alert(
        <div style={{ fontSize: 16 }}>请核实修改后的通道信息？</div>,
        <div>
          <List>
            <List.Item><span style={{ fontSize: 14 }}>产品：视频短信ISMS</span></List.Item>
            <List.Item><span style={{ fontSize: 14 }}>配置类型：{`${ChannelType[searchInfo.channelType]}`}</span></List.Item>
            <List.Item><span style={{ fontSize: 14 }}>协议类型：{`${ProtoType[searchInfo.protoType]}`}</span></List.Item>
            <List.Item><span style={{ fontSize: 14 }}>短信类型：{`${SelectPurpose[searchInfo.purpose]}`}</span></List.Item>
            {searchInfo.channelType === 3 && searchInfo.organizationId && searchInfo.organizationId.length && searchInfo.companyInfo ?
              <List.Item><span style={{ fontSize: 14, whiteSpace: 'break-spaces', display: 'inline-block' }}>项目ID：{`${searchInfo.companyInfo.OrganizationName || '-'}-(${searchInfo.companyInfo.OrganizationId || '-'})-(${searchInfo.companyInfo.OrganizationAlias || '-'})`}</span></List.Item> : null}
          </List>
          <Accordion className='list-accordion'>
            <Accordion.Panel header={<span style={{ fontWeight: 500, fontSize: 14 }}>通道信息：</span>}>
              <List>
                {(weights || []).map((channel, index) => <List.Item key={index}>
                  <div className='list-text-sm'>名称：{channel.Channel}</div>
                  <div className='list-text-sm'>运营商：{AllOperatorType[channel.Provider] || '全部'}</div>
                  <div className='list-text-sm'>权重：【{channel.Weight}】</div>
                </List.Item>)}
              </List>
            </Accordion.Panel>
          </Accordion>
        </div>,
        [
          { text: '取消', onPress: () => {}, style: 'default' },
          { text: '确定', onPress: () => {
        
              if (info.Id) {
                fetchUpdate(weights);
              } else {
                fetchCreate(weights);
              }
            }
        }]
      );
    }
  };

  const getResult = () => {
    return [...allList, ...vendorList]
  }

  // 权重总和校验，总和不超过100, 配置了All，就以all的权重为准
  const checkWeight = () => {
    const providerWeights = arrayGroupByObjectKey([...allList, ...vendorList], 'Provider') || {};

    if (Object.keys(providerWeights).length === 0) {
      return true;
    }

    let allWeight = 0;
    Object.keys(providerWeights)
      // .filter(type => type !== 'all')
      .forEach(type => {
        // 找各个运营商的权重总和
        let sum = 0;
        providerWeights[type].forEach(item => {
          sum += +item.Weight;
        });
        if (allWeight < sum) {
          allWeight = sum;
        }
      });
    return allWeight <= sumWeight;
  };

  const fetchCreate = weights => {
    let channels = [];
    weights.forEach(item => {
      if (!channels.includes(item.channel)) {
        channels.push(item.Channel);
      }
    });
    const data = {
      OrganizationId: (info.OrganizationId && info.OrganizationId.length) ? info.OrganizationId[0] : null,
      BrevityCode: info.BrevityCode,
      Purpose: info.Purpose,
      ProtoType: info.ProtoType,
      Channels: channels,
      ChannelWeights: weights
    };

    setBtnLoading(true);
    CreateChannelControl(data).then(res => {
      setBtnLoading(false);
      if (res.RetCode === 0) {
        Toast.success('创建通道配置成功');
        // 操作日志
        addChannelRecord({
          OperatorTypeId: RecordCreateType,
          RelatedId: res.Data ? String(res.Data.Id) : '0',
          Content: ChannelType[channelType],
        });
        fetchBack();
      } else {
        Toast.fail(res.Message || '创建失败')
      }
    });
  };

  const fetchUpdate = weights => {
    let channels = [];
    weights.forEach(item => {
      if (!channels.includes(item.channel)) {
        channels.push(item.Channel);
      }
    });
    const data = {
      Id: info.Id,
      Channels: channels,
      ChannelWeights: weights
    };

    setBtnLoading(true);
    UpdateChannelControl(data).then(res => {
      setBtnLoading(false);
      if (res.RetCode === 0) {
        Toast.success('修改通道配置成功');
        fetchBack();
        // 操作日志
        addChannelRecord({
          OperatorTypeId: RecordUpdateType,
          RelatedId: info.Id.toString(),
          Content: `${'（企业微信端）默认通道配置：' + info.ChannelWeight} ==> ${JSON.stringify(weights)}`,
        });
      } else {
        Toast.fail(res.Message || '修改失败')
      }
    });
  };

  return (
    <>
      {(info && info.Id !== undefined) || info.New ? <>
        <div style={{ margin: '10px 0' }}>
          <NoticeBar marqueeProps={{ loop: true }}>
            {`各个运营商权重总和分别为：100。向右滑动条目可以进行添加和删除操作。`}
          </NoticeBar>
        </div>

        <div style={{ marginTop: '4px' }}>
          <span>选择配置运营商方式：</span>
          <Radios
            value={operatorType}
            style={{ whiteSpace: 'nowrap' }}
            onChange={value => setOperatorType(value)}
            options={Object.keys(types).map(item => ({ label: types[item], value: item }))} />
        </div>

        {operatorType === 'all' ? <ConfigEditorProvider
          list={allList}
          setList={list => setAllList(list)}
          sumWeight={sumWeight}
          info={info}
          onlyShowAll
        /> : null}
        {operatorType === 'other' ? <ConfigEditorProvider
          list={vendorList}
          setList={list => setVendorList(list)}
          sumWeight={sumWeight}
          info={info}
          onlyShowNoAll
        /> : null}

        <div style={{ margin: '20px 0', borderBottom: '1px solid #ddd' }}>
          {!checkWeight() ? (
            <NoticeBar marqueeProps={{ loop: true, style: { padding: '0 7.5px' } }} style={{ margin: '8px 0' }}>
              {`通道总权重 > ${sumWeight}，请调整权重配置`}
            </NoticeBar>
          ) : null}
        </div>

        <Button type="primary" loading={btnLoading} disabled={btnLoading || !checkWeight()} onClick={() => {
          handleOk();
        }}>确定</Button>
      </> : <NoticeBar marqueeProps={{ style: { padding: '0 7.5px' } }} style={{ marginTop: '8px' }}>
        {`请先选择正确的通道信息，再进行编辑`}
      </NoticeBar>}
    </>
  );
}
export default IsmsConfigEditor;
